import { SprinklesElement } from "sprinkles-js";

export default class ImageInputElement extends SprinklesElement {
  static tagName = "image-input";
  static refs = ["preview", "input"];
  static events = {
    change: { ref: "input", method: "handleInput" },
    drop: "handleDrop",
    dragover: "handleDragover",
  };

  afterConnected() {
    this.fileReader = new FileReader();
    this.fileReader.onload = (event) => {
      this.refs.preview.src = event.target.result;
      // If the preview was hidden before, we now reveal it
      this.refs.preview.removeAttribute("aria-hidden");
    };
  }

  handleInput(event) {
    const file = event.target.files[0];
    this.fileReader.readAsDataURL(file);
  }

  handleDrop(event) {
    event.preventDefault();

    // Ignore if dataTransfer doesn't contain exactly one item
    if (event.dataTransfer.files.length !== 1) return;

    const dataTransfer = new DataTransfer();
    // Only keep file if an image
    for (const file of event.dataTransfer.files) dataTransfer.items.add(file);

    if (dataTransfer.files.length === 0) return;

    this.refs.input.files = dataTransfer.files;
    this.fileReader.readAsDataURL(dataTransfer.files[0]);
  }

  handleDragover(event) {
    // Just here to prevent the browser from opening the file
    event.preventDefault();
  }
}
